import React, { useState, useEffect } from "react";
import { Modal, Button, Nav, NavItem, NavLink } from 'react-bootstrap';
import './Campaigns.css';


const ModalNoPlanActive = ({ show, handleModalhide }) => {



    return (
        <>
            <Modal show={show} onHide={handleModalhide} dialogClassName="reset-width-modal modal-width-50" >
                <Modal.Header closeButton>
                    <Modal.Title>Informação</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        <div className="col-12">
                            Não têm nenhum plano ativo neste momento, subscreva ou renove o seu plano para poder usufruir deste serviço
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleModalhide}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}


export default ModalNoPlanActive